import { ContryId, FBDate } from "./Globals"
import { KnowledgeTest } from "./InvestmentKnowledge"
import { PropertyBagData } from "./KYCPolicy"
import { LanguageId } from "./Language"
import { ChannelId } from "./Post"

export type InvestorId = string

export enum KYCStatus {
    Incomplete = "Incomplete",
    Aprroved = "Aprroved",
    Pending = "Pending"
}

export type AccountId = string

export type Account = {
    accountId: AccountId;
    accountName: string;
    country: ContryId;
    company: boolean;
    kycStatus: KYCStatus;
    kycData: PropertyBagData;
    knowledgeTest?: KnowledgeTest;
    experiencedInvestorApprovedDate?: FBDate;
}

export const tryGetField = (accont: Account, field: string): string => {
    const possibleField = accont.kycData[field]
    if (possibleField) return possibleField.content
    else return 'COULD NOT FIND: [' + field + ']'
}

export enum InvestorNotificationStates {
    DisableOnboarding = "DisableOnboarding",
    Granted = "Granted",
    CanceledByProvider = "CanceledByProvider",
    DisabledByUser = "DisabledByUser"
}

export type SetupNotificationsProps = {
    pushToke: string;
}

export type DeviceId = string
export type InvestorNotificationStatus = {
    deviceId: DeviceId;
    state: InvestorNotificationStates,
    pushToke: string
}

export type Investor = {
    investorId: InvestorId;
    fname: string;
    lname: string;
    email: string;
    country: ContryId;
    phone: string;
    language: LanguageId;
    onboardingCompleted: boolean;
    accounts: Account[];
    channels: ChannelId[];
    notificationInfo?: InvestorNotificationStatus[];
    investorSource?: string;
    created: FBDate;
    loginMethod: string;
    lastActive?: FBDate;
}

export type AccountCreateProps = {
    accountName: string;
    country: ContryId;
    company: boolean;
}

export type InvestorCreateProps = {
    fname: string;
    lname: string;
    email: string;
    phone: string;
    country: ContryId;
    language: LanguageId;
    investorSource?: string;
    acceptNewsletter?: boolean;
}

export type UpdateInvestorLanguageProps = {
    language: LanguageId;
}

export type UpdateInvestorChannelProps = {
    affecredChannel: ChannelId;
    addAction: boolean;
}

export type UpdateInvestorChannelIncognitoProps = UpdateInvestorChannelProps & {
    investorId: InvestorId
}

export type InvestorAlias = {
    id: InvestorId;
    aliasOf: InvestorId;
}

export type CreateAliasIfPossibleProps = {
    username: string;
}

export type CreateAliasIfPossibleResponse = {
    successfullySetupAlias: boolean;
}

export default Investor